import { CodeNext, ConceptStatusValueType } from "@fusion-advantage/backcompat"
import { FormThunk } from "../../redux/formStore"
import { useFormAppRelay } from "../relay/FormAppRelay"
import { submitStatusUpdates } from "../../redux/submitStatusUpdates"
import { cidForDirItemId, proposeFormSubmitEvaluatorSignatureWipe } from "@fusion-advantage/formlib"
import { cleanupDiagnosisReviewAuditDecisions } from "../../redux/diagnosisReviewSlice"

interface submitFormThunkArgs {
	codeNext: CodeNext
}

export const submitForm = ({codeNext}: submitFormThunkArgs): FormThunk<Promise<void>> => async (dispatch, getState) => {
	const formAppRelay = useFormAppRelay()
	const validityByCid = getState().form.conceptStatusValidity
	return formAppRelay.submitForm({
		codeNext,
		validityByCid,
	})
}

interface formFinalizeForSubmitThunkArgs {
	submitToCode: CodeNext
}

export const formFinalizeForSubmit = ({submitToCode}: formFinalizeForSubmitThunkArgs): FormThunk<Promise<void>> => async (dispatch, getState) => {
	dispatch(cleanupDiagnosisReviewAuditDecisions())
	const rPropose = proposeFormSubmitEvaluatorSignatureWipe(submitToCode)
	if(rPropose.isOk()) {
		dispatch(submitStatusUpdates([{
			cid: cidForDirItemId(391),
			value: null,
			valueType: ConceptStatusValueType.Derived,
		}]))
	}
}
